<template>
<div>
  <div>

  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="70vh">
      <el-table-column prop="house_name" label="房产" width="300"></el-table-column>
      <el-table-column prop="meter_type_name" label="仪表类型" width="100"></el-table-column>
      <el-table-column prop="number" label="仪表编号 "  width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="180"></el-table-column>
      <el-table-column prop="children_count" label="下级数量" width="100"></el-table-column>
      <el-table-column prop="status" label="是否在用 " width="100">
        <template slot-scope="scope">
          {{scope.row.status===1?'启用':'停用'}}
        </template>
      </el-table-column>
      <el-table-column label="操作 ">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showMapNode(scope.row)" >架构图</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>

  <MeterInfo ref="MeterInfo" />

  <MeterMap ref="MeterMap" />
</div>
</template>

<script>
import MeterMap from "./components/MeterMap";
import MeterInfo from "./components/MeterInfo";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterMapList",
  components: {MeterInfo, MeterMap},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = {
        house_name:that.mainObj.house_name,
        project_id:that.mainObj.project_id
      };
      MeterHttp.post("Meter/getMeterLevelOne?user_type="+(that.$route.query.type||0),{
        ...where,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    showMap(item){
      const that=this;
      ERP.showLoading();
      that.$refs.MeterMap.show(item.id,ret=>{
        ERP.hideLoading();
      })
    },
    edit(item) {
      this.$refs.MeterInfo.show(item);
    },
    showMapNode(item){
      // this.$refs.MeterMapNodeEditorRef.show(item.id);
      window.open("/#/show/MeterMapEditor?meterId="+item.id+"&projectId="+item.project_id+"&type="+this.$route.query.type)
    }
  },
  watch:{
    "mainObj.house_name":function (n) {
      const that=this;
      that.pageChange(1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterMapList.vue